import api from '../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import { changeBodyToForm } from "../../../utils"
import { GET_EVENTS, CREATE_EVENT, UPDATE_EVENT, DELETE_EVENT } from "./actionsType";
import { GET_EVENTS_SUCCESS, CREATE_EVENT_SUCCESS, UPDATE_EVENT_SUCCESS, SET_LOADER, DELETE_EVENT_SUCCESS } from "./mutationType"



const state = {
    events: {},
    dollar_percent: null,
    ids: [],
    isLoading: false,
    manager_id: null
}



const getters = {
    eventsIds: (state) => state.ids,
    hadEventsIds: (state, getters) => getters.eventsIds.length > 0,
    getEventById: (state) => (id) => state.events[id],
    getEventStatus: (state, getters) => (id) => getters.getEventById(id).status === 0 ? "message.inactive" : "message.active"
}

const mutations = {
    [GET_EVENTS_SUCCESS](state, { ids, data, dollar_percent } ) {
        state.ids = ids
        state.events = { ...state.events, ...data }
        state.manager_id = data[ids[0]].ticket_manager_id
        state.dollar_percent = Math.round(parseInt(dollar_percent))
    },
    [CREATE_EVENT_SUCCESS](state, { data: event }) {
        state.ids = [event.id, ...state.ids]
        state.events = { ...state.events, [event.id]: event }
    },
    [UPDATE_EVENT_SUCCESS](state, { data: event }) {
        state.events = { ...state.events, [event.id]: event }
    },
    [SET_LOADER](state, value) {
        state.isLoading = value
    },
    [DELETE_EVENT_SUCCESS](state, id) {
        const indexToDelete = state.ids.indexOf(id)
        state.ids = [
            ...state.ids.slice(0, indexToDelete),
            ...state.ids.slice(indexToDelete + 1)
        ]
    }
}

const actions = {
    async [GET_EVENTS]({ commit }) {
        Nprogress.start();
        try {
            const { data } = await api.get("ticket/ticket-bots")
            const {ids, data: events} = data;
            let dollar_percent = await api.get(`ticket/ticket-manager/${events[ids[0]].ticket_manager_id}`)
                .then(response => {
                    return response.data.data.dollar_percent
                });
            commit(GET_EVENTS_SUCCESS, {...data, dollar_percent})
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    setDollarPercent({commit}, dollar_percent){
        Nprogress.start();
        try {
            api.put(`https://api.tubotones.com/api/ticket/ticket-manager/${state.manager_id}`, {
                dollar_percent
            })
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ Tasa actualizada con éxito`
            })
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    async [CREATE_EVENT]({ commit, state }, payload) {
        if (state.isLoading) return
        commit(SET_LOADER, true)
        Nprogress.start();
        try {
            const { data } = await api.post("ticket/ticket-bots", changeBodyToForm(payload.event), {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            commit(CREATE_EVENT_SUCCESS, data)
            payload.close()
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ ${data.message}`
            })
            console.log(data)
        } catch (err) {
            somethingWentWrong(err)
        }
        commit(SET_LOADER, false)
        Nprogress.done();
    },
    async [UPDATE_EVENT]({ commit, state }, payload) {
        if (state.isLoading) return
        commit(SET_LOADER, true)
        Nprogress.start();
        try {
            const { data } = await api.post(`ticket/ticket-update/${payload.id}`, changeBodyToForm(payload.event))
            commit(UPDATE_EVENT_SUCCESS, data)
            payload.close()
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ ${data.message}`
            })
            console.log(data)
        } catch (err) {
            somethingWentWrong(err)
        }
        commit(SET_LOADER, false)
        Nprogress.done();
    },
    async [DELETE_EVENT]({ commit, state }, payload) {
        if (state.isLoading) return
        commit(SET_LOADER, true)
        Nprogress.start();

        try {
            const { data } = await api.delete(`ticket/ticket-bots/${payload.id}`)
            commit(DELETE_EVENT_SUCCESS, payload.id)
            payload.close()
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ Delete Successfully`
            })
        } catch (err) {
            somethingWentWrong(err)
        }
        commit(SET_LOADER, false)
        Nprogress.done();
    }
}
const somethingWentWrong = (err) => {
    console.table(err.data)
    Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
    })
}

export default {
    state,
    getters,
    mutations,
    actions
}
